import { z } from 'zod'

/** One thing Pulsify remembers about a person: what their own words meant. */
export const userMemorySchema = z.object({
  id: z.string().uuid(),
  /** The person's own words, folded to lower case. */
  phrase: z.string(),
  kind: z.enum(['listing', 'spot']),
  /** Null once the place no longer exists. */
  placeName: z.string().nullable(),
  uses: z.number().int(),
  lastUsedAt: z.string(),
})

export const userMemoriesResponseSchema = z.object({
  memories: z.array(userMemorySchema),
})

export const deleteMemoriesResponseSchema = z.object({
  deleted: z.number().int(),
})

export type UserMemoryDto = z.infer<typeof userMemorySchema>
export type UserMemoriesResponse = z.infer<typeof userMemoriesResponseSchema>
export type DeleteMemoriesResponse = z.infer<typeof deleteMemoriesResponseSchema>
